export default __webpack_public_path__ + "static/media/Linkedin.209bcc84.jpg";